export type PaymentQuery = {
  /**
   * Публичный идентификатор мерчанта (идет в открытом виде в URL path).
   */
  merchantId?: string;

  /**
   * Зашифрованный payload из URL path.
   */
  payload?: string;

  /**
   * Дополнительные необязательные параметры.
   */
  orderID?: string;
  apiBaseOverride?: string;
};

/**
 * Проверяет, что строка не пустая (не undefined, не null, не пустая строка)
 */
function isNonEmptyString(value: string | undefined | null): value is string {
  return value !== undefined && value !== null && value !== '';
}

/**
 * Парсер URL для Payment Page.
 * Ожидаем формат /{merchant_id}/{payload}?query...
 */
export function parsePaymentQuery(location: Location): PaymentQuery {
  const params = new URLSearchParams(location.search ?? '');
  const rawSegments = location.pathname.split('/').filter(Boolean);

  const paymentQuery: PaymentQuery = {};

  if (rawSegments.length >= 1) {
    paymentQuery.merchantId = decodeURIComponent(rawSegments[0]);
  }

  if (rawSegments.length >= 2) {
    paymentQuery.payload = decodeURIComponent(rawSegments[1]);
  }

  if (params.has('orderID')) {
    paymentQuery.orderID = paymentQuery.orderID ?? params.get('orderID') ?? undefined;
  }

  if (!isNonEmptyString(paymentQuery.merchantId) && params.has('merchant_id')) {
    paymentQuery.merchantId = params.get('merchant_id') ?? undefined;
  }

  if (!isNonEmptyString(paymentQuery.payload) && params.has('payload')) {
    paymentQuery.payload = params.get('payload') ?? undefined;
  }

  if (params.has('api_base')) {
    paymentQuery.apiBaseOverride = params.get('api_base') ?? undefined;
  }

  return paymentQuery;
}

